module.exports = __webpack_public_path__ + "img/lsdslogo.74aaea42.png";